import React, { useContext } from 'react';
import cx from 'classnames';

import { Dropdown } from 'components';
import { M } from 'components/typography';
import { useChargeCodesOptions } from 'pages/portal/admin/channel/charges-invoices/hooks/useChargeCodesOptions';
import { useTranslation } from 'react-i18next';
import { ChannelsContext } from 'lane-shared/contexts';

import styles from './CreateProductForm.scss';

type AdminFeeChargeCodeDropdownProps = {
  adminFeeChargeCodeId?: string;
  updateDetails: (value: any, field: string) => void;
};

export function AdminFeeChargeCodeDropdown({
  adminFeeChargeCodeId,
  updateDetails,
}: AdminFeeChargeCodeDropdownProps) {
  const { t } = useTranslation();

  const { primaryChannel } = useContext(ChannelsContext);
  const channelId = primaryChannel?._id;

  const chargeCodeOptions = useChargeCodesOptions(channelId);

  return (
    <>
      <div className={styles.label}>
        <label className={styles.descriptionLabel}>
          {t('abp.productsServices.createProduct.adminFeeChargeCodeLabel')}
        </label>
      </div>
      <Dropdown
        testId="adminFeeChargeCodeDropdown"
        doTranslation={false}
        className={cx(
          styles.inputFields,
          styles.inputWithCustomLabel,
          styles.categoryDropdown
        )}
        value={adminFeeChargeCodeId}
        placeholder={t(
          'abp.productsServices.createProduct.chargeCode.placeholder'
        )}
        items={chargeCodeOptions}
        onChange={(item: { value: string }) => {
          updateDetails(item.value, 'adminFeeChargeCodeId');
        }}
      />
      <M>
        {t(
          'abp.productsServices.createProduct.adminFeeChargeCode.helperText'
        )}
      </M>
    </>
  );
}
